import ExecutionStateParser from './ExecutionStateParser';
import { ActionState, ExecutionStatus } from './ExecutionConstants';

class ExecutionDeploymentActionStateParser {
    private execution: any;
    private executionStatus: ExecutionStatus;

    constructor(execution: any) {
        this.execution = execution;
        this.executionStatus = new ExecutionStateParser().parseState(execution).status;
    }

    getActionState(actionName: string) {
        if (this.executionStatus === ExecutionStatus.AwaitingApprovals ||
            this.executionStatus === ExecutionStatus.Scheduled ||
            this.executionStatus === ExecutionStatus.Ready) {
            return ActionState.NotStarted;
        }

        const action = this.execution.DeploymentList.find(item => item.ActionName === actionName);

        if (!action) {
            if (this.executionStatus === ExecutionStatus.Failed) {
                return ActionState.NotStarted;
            } else if (this.executionStatus === ExecutionStatus.Passed) {
                return ActionState.Unknown;
            } else {
                return ActionState.Pending;
            }
        }

        if (action.Errors && action.Errors.length) {
            return ActionState.Failed;
        }

        switch (this.execution.ExecutionPlan) {
            case 'DEPLOY_WITHOUT_TEARDOWN':
            case 'DEPLOY':
                if (action.DeploymentState.includes('FAILED')) {
                    return ActionState.Failed;
                } else if (action.DeploymentState === 'COMPLETE') {
                    return ActionState.Passed;
                } else if (this.executionStatus === ExecutionStatus.Failed) {
                    return ActionState.Unknown;
                } else {
                    return ActionState.InProgress;
                }
            case 'DEPLOY_WITH_TEARDOWN':
            case 'DEPLOY_TEARDOWN':
                if (action.DeploymentState.includes('FAILED') || action.TeardownState.includes('FAILED')) {
                    return ActionState.Failed;
                } else if (action.DeploymentState === 'COMPLETE' && action.TeardownState === 'TORN_DOWN') {
                    return ActionState.Passed;
                } else if (this.executionStatus === ExecutionStatus.Failed) {
                    return ActionState.Unknown;
                } else {
                    return ActionState.InProgress;
                }
            case 'TEARDOWN_ALL':
                if (action.TeardownState.includes('FAILED')) {
                    return ActionState.Failed;
                } else if (action.TeardownState === 'TORN_DOWN') {
                    return ActionState.Passed;
                } else if (this.executionStatus === ExecutionStatus.Failed) {
                    return ActionState.Unknown;
                } else {
                    return ActionState.InProgress;
                }
            default:
                return ActionState.Unknown;
        }
    }
}

export default ExecutionDeploymentActionStateParser;